<div *ngIf="hasSchedulesFF; else oldChip" class="schedules-ff">
	<!-- Student Group chip -->
	<div
		*ngIf="!isUser && studentList"
		class="selection tw-relative"
		[ngClass]="{ 'hovered-chip': hovered }"
		(mouseover)="hovered = true"
		(mouseleave)="hovered = false">
		<img class="group-icon" src="../../../../../assets/Groups Icon.svg" />
		<div class="name">{{ studentList.title }}</div>
		<div
			class="close-button tw-cursor-pointer tw-rounded-lg"
			(click)="removeSelection(studentList)"
			*ngIf="showIcon"
			(mouseover)="iconHovered = true"
			(mouseleave)="iconHovered = false"
			[ngClass]="{ 'hovered-icon': iconHovered }">
			<img src="../../../../../assets/close-x-tiny.svg" alt="remove selection icon" />
		</div>
	</div>

	<!-- Individual User chip -->
	<div
		*ngIf="isUser && student"
		class="selection tw-relative"
		[ngClass]="{ locked: locked, hover: showIcon }"
		(mouseover)="hovered = true"
		(mouseleave)="hovered = false">
		<div
			*ngIf="student.profile_picture; else d"
			[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover' }"
			class="profile-picture"></div>
		<ng-template #d>
			<img class="profile-picture" src="../../../../../assets/Avatar (Gray-400).svg" alt="Avatar" />
		</ng-template>
		<div class="name">
			<div>{{ student.display_name }}</div>
		</div>
		<div *ngIf="!locked && showIcon" (click)="removeSelection(student)" (mouseover)="iconHovered = true" (mouseleave)="iconHovered = false">
			<div class="close-button tw-cursor-pointer tw-rounded-lg" [ngClass]="{ 'hovered-icon': iconHovered }">
				<img src="../../../../../assets/close-x-tiny.svg" alt="remove selection icon" />
			</div>
		</div>
		<div
			*ngIf="locked"
			class="lock-icon tw-rounded-lg"
			customToolTip
			[showToolTip]="locked"
			[contentTemplate]="tooltipContent"
			(mouseover)="iconHovered = true"
			(mouseleave)="iconHovered = false"
			[ngClass]="{ 'hovered-icon': iconHovered }">
			<img class="tw-h-3" src="./../../../../assets/Lock (Small).svg" />
		</div>
	</div>
</div>

<ng-template #oldChip>
	<div class="no-schedules-ff">
		<div *ngIf="!isUser && studentList" class="selection">
			<img class="group-icon" src="../../../../../assets/Groups Icon.svg" />
			<span class="name">{{ studentList.title }}</span>
			<img class="close-button" src="../../../../../assets/Close (Navy).svg" (click)="removeSelection(studentList)" />
		</div>

		<div *ngIf="isUser && student" class="selection">
			<div
				*ngIf="student.profile_picture; else d"
				[ngStyle]="{ background: 'url(' + student.profile_picture + ') no-repeat left center/cover' }"
				class="profile-picture"></div>
			<ng-template #d>
				<img class="profile-picture" src="../../../../../assets/Avatar (Gray-400).svg" alt="Avatar" />
			</ng-template>
			<span class="name">{{ student.display_name }}</span>
			<img class="close-button" src="../../../../../assets/Close (Navy).svg" (click)="removeSelection(student)" />
		</div>
	</div>
</ng-template>
